import { inject as service } from '@ember/service';
import ApplicationAdapter from 'cio/adapters/application';
import AccountsListService from 'cio/services/accounts-list';
import { DataCenter } from 'cio/models/account';
import { getHostForDataCenter } from 'cio/utils/data-centers';

export default class AuditLogAdapter extends ApplicationAdapter {
  @service accountsList!: AccountsListService;

  urlForQuery(query: Record<string, any>) {
    // We may want to send the request to a specific datacenter.
    let dataCenter: DataCenter | null = null;

    if (query.object_type === 'Account' && query.object_id !== null) {
      dataCenter = this.accountsList.getDataCenterByAccountId(query.object_id);
    } else if (query.env != null) {
      dataCenter = this.accountsList.getDataCenterByEnvironmentId(query.env);
    }

    let host = dataCenter != null ? getHostForDataCenter(dataCenter) : this.host;

    return `${host}/${this.namespace}/admin/inspect/for_object`;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'audit-log': AuditLogAdapter;
  }
}
